module.exports = __webpack_public_path__ + "img/feature_buy_en.b0eb6427.png";